import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=1a433eed"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a433eed')) {
      api.createRecord('1a433eed', component.options)
    } else {
      api.reload('1a433eed', component.options)
    }
    module.hot.accept("./ChangePasswordCard.vue?vue&type=template&id=1a433eed", function () {
      api.rerender('1a433eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/ChangePasswordCard.vue"
export default component.exports